var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { BarIndex } from '@shared/commons/cache/History/HistoryConstants';
import { MovingAverageMap } from './IVolumeBarsMovingAverage';
export class VolumeBarsMovingAverage {
    constructor() {
        this.movingAveragePeriod = 21;
    }
    setMovingAveragePeriod(period) {
        this.movingAveragePeriod = period;
    }
    calculateMovingAverage(cashItemSeries, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve) => {
                if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                    resolve(null);
                }
                else {
                    resolve(this.calculateMovingAverageMapProcess(cashItemSeries));
                }
            });
        });
    }
    calculateMovingAverageMapProcess(cashItemSeries) {
        var _a;
        const volumes = new Map();
        const count = cashItemSeries.Count();
        for (let i = cashItemSeries.leftPaddingBarsCount; i < count; i++) {
            const volume = cashItemSeries.GetValue(i, BarIndex.Volume);
            if (!volumes.has(i)) {
                volumes.set(i, volume);
            }
            else {
                // Return or handle the case where volumes already has the current index
                // Depending on your logic, you might want to log an error or handle it differently
                return MovingAverageMap(); // or throw an error, etc.
            }
        }
        const map = MovingAverageMap();
        const startIndex = this.movingAveragePeriod + cashItemSeries.leftPaddingBarsCount - 1;
        for (let i = startIndex; i < count; i++) {
            let sum = 0;
            for (let j = i - (this.movingAveragePeriod - 1); j <= i; j++) {
                sum += (_a = volumes.get(j)) !== null && _a !== void 0 ? _a : 0;
            }
            map === null || map === void 0 ? void 0 : map.set(cashItemSeries.GetIndex(i), sum / this.movingAveragePeriod);
        }
        return map;
    }
}
